import { UserOption } from "components/MultipleUserPicker";

/** First selected user id from a single-select picker, or null when cleared. */
export function firstUserId(users: UserOption[] | null): string | null {
  return users && users.length > 0 ? (users[0]?.id ?? null) : null;
}
